export const VALIDATION_PATTERNS = {
  email: /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/,
  phone: /^\+?[0-9]{7,16}$/,
  name: /^[A-Za-zäöüßÄÖÜ\s-]+$/,
  password:
    /^(?=.*[a-zäöüß])(?=.*[A-ZÄÖÜ])(?=.*\d)(?=.*[#?!@$%^&*\-\.+=])[A-Za-zäöüßÄÖÜ\d#?!@$%^&*\-\.+=]{8,}$/,
} as const;
